

















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import { Element, Product } from '@/models'
import { CV_VALUE_FULL_CPG, TYPR_DIGITAL_COURSE } from '@/utils/constants'

@Component({
  components: {}
})
export default class IndesignFileExample extends Vue {
  @Prop({ required: true, type: Object }) readonly product: Product
  @Prop({ required: true, type: Object }) readonly element: Element

  private partsOptions = [
    { key: 'adh', label: 'Adhesivos' },
    { key: 'adhint', label: 'Adhesivos interior' },
    { key: 'anexo', label: 'Anexo de bloque' },
    { key: 'anexo', label: 'Anexo' },
    { key: 'cama', label: 'Cama' },
    { key: 'cred', label: 'Creditos' },
    { key: 'cub', label: 'Cubierta' },
    { key: 'fin', label: 'Fin' },
    { key: 'guard', label: 'Guardas' },
    { key: 'ind', label: 'Indice' },
    { key: 'ini', label: 'Iniciales' },
    { key: 'intercomp', label: 'Interior completo' },
    { key: 'intermed', label: 'Intermedio de bloque' },
    { key: 'intermed', label: 'Intermedio' },
    { key: 'port', label: 'Portadilla' },
    { key: 'present', label: 'Presentacion' },
    { key: 'recort', label: 'Recortables' },
    { key: 'res', label: 'Reserva' },
    { key: 'serig', label: 'Serigrafía' },
    { key: 'troqu', label: 'Troquel' }
  ]

  private partTypeSelected = ''
  private freeText = ''

  get isDigitalCourse() {
    return this.product.type === TYPR_DIGITAL_COURSE
  }

  get nameNotFullCpg() {
    let text = `${this.product.code}_${this.element.code}_000-000_`
    if (this.partTypeSelected !== '') {
      text += `${this.partTypeSelected}`
    } else {
      text += `[${this.$t('product_detail.tab_info.indesing_example_name.type_part')}]`
    }
    return text
  }

  get nameFullCpg() {
    let text = ''
    if (this.element.metadata.fileNameDefault) {
      text = this.element.metadata.fileNameDefault
      if (this.freeText) {
        text += `__${this.freeText}`
      }
    } else {
      if ((this.isDigitalCourse && this.product.editorialProjectComplete && this.product.editorialProjectComplete.fileNameRuleCountryDigital) ||
      (!this.isDigitalCourse && this.product.editorialProjectComplete && this.product.editorialProjectComplete.fileNameRuleCountryBook)
      ) {
        text += this.product.country?.split('-')[1]
      }
      text += `${this.product.code}_${this.element.code}`
    }
    return text
  }

  get isFullCpg() {
    if (!this.product.editorialProjectComplete) {
      return false
    }
    return this.product.editorialProjectComplete.productionMode === CV_VALUE_FULL_CPG
  }

  private async copyClipboard(text: string) {
    try {
      await navigator.clipboard.writeText(text)
    } catch (err) {
      console.error('Error al copiar: ', err)
    }
  }
}
